import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouteSelectionService } from '../../services/route-selection';
import { RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Route } from '../../services/routes';

@Component({
  selector: 'app-sales',
  templateUrl: './sales-component.html',
  styleUrls: ['./sales-component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    MatButtonModule,
    RouterModule
  ]
})

export class SalesComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  selectedRoute: Route | null = null;

  constructor(private routeService: RouteSelectionService) { }

  ngOnInit() {
    this.routeService.selection$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(route => {
      this.selectedRoute = route;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

